/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import $ from 'jquery';
import cx from 'classnames';
import Update from 'immutability-helper';
import {
  Loader, Popup, Icon, Dropdown, Label
} from 'semantic-ui-react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Scrollbars } from 'react-custom-scrollbars-2';
import api from '../../api';
import progress from '../../images/icons/progress_ica.gif';
import searchImg from '../../images/components/left_menu/searchIcon.png';
import foldImg from '../../images/components/left_menu/foldIcon.png';
import expandImg from '../../images/components/left_menu/expandIcon.png';
import bulletImg from '../../images/components/left_menu/bullet.png';
import combinedShapeImg from '../../images/components/my/my-combined-shape.svg';
import '../NavBar/ScanNavBar.css';

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      hasMore: true,
      isLoading: false,
      isLoadingTree: false,
      isLoadingFiles: false,
      isShowMoreLoading: false,
      isPageLoading: false,
      loadingIndex: '',
      uploadedDataList: props.uploadedDataList,
      projectDataList: props.projectDataList,
      currentPage: 1,
      searchKeyword: '',
      selected: 'uploaded',
      activeTab: props.activeTab,
      errSearch: false,
      selectedIndex: props.selectedIndex,
      targetObject: 'project',
      parentId: 0,
      activeIndex: props.activeIndex,
      hasMoreProject: false,
      hasMoreProjectVersion: [],
      hasMoreReport: [],
      projectSize: 20,
      projectVersionSize: 20,
      projectReportSize: 20,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleAddtoBookmark = this.handleAddtoBookmark.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.getMoreListData = this.getMoreListData.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.left_menu_type_2 .projects_list_wrap .projects_list ul li a span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      uploadedDataList,
      activeTab,
      activeIndex,
      projectDataList,
      selectedIndex
    } = this.props;

    const { isPageLoading } = this.state;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getUploadedData();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.uploadedDataList.length !== uploadedDataList.length) {
      this.setState({
        uploadedDataList,
      });
    }

    if (prevProps.activeTab !== activeTab) {
      this.setState({
        isShowMoreLoading: false,
        activeTab,
        selectedIndex: [],
      });
    }

    if (prevProps.activeIndex !== activeIndex) {
      this.setState({
        activeIndex,
      });
    }

    if (prevProps.projectDataList.length !== projectDataList.length) {
      this.setState({
        projectDataList,
      });
    }

    if (prevProps.selectedIndex.length !== selectedIndex.length) {
      this.setState({
        selectedIndex,
      });
    }
  }

  handleSortingChange(e, data) {
    const { activeTab, selected } = this.state;

    if (activeTab === 'files') {
      if (selected === data.value) {
        return;
      }
      return this.setState(
        {
          selected: data.value,
          uploadedDataList: [],
        },
        () => {
          this.getUploadedData();
        }
      );
    }
    if (selected === data.value) {
      return;
    }
    return this.setState(
      {
        selected: data.value,
        projectDataList: [],
        targetObject: 'project',
        parentId: 0,
      },
      () => {
        this.getLeftProjectList();
      }
    );
  }

  handleSearch(event) {
    const { activeTab } = this.state;
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return;
      }

      if (activeTab === 'files') {
        this.setState(
          {
            searchKeyword: event.target.value,
            uploadedDataList: [],
          },
          () => {
            this.getUploadedData();
          }
        );
      } else {
        this.setState(
          {
            searchKeyword: event.target.value,
            projectDataList: [],
          },
          () => {
            this.getLeftProjectList();
          }
        );
      }
    }
  }

  handleTabChange(e) {
    const { translate, handleTabChange, updateTreeIndex } = this.props;
    const { activeTab } = this.state;

    if (e.target.text === translate('my_page.files')) {
      if (activeTab === 'files') {
        return;
      }
      return this.setState({
        activeTab: 'files',
        projectDataList: [],
        searchKeyword: '',
        selected: 'uploaded',
      }, () => {
        this.search.value = '';
        this.getUploadedData();
        handleTabChange('files');
      });
    }

    if (activeTab === 'projects') {
      return;
    }
    return this.setState({
      activeTab: 'projects',
      targetObject: 'project',
      parentId: 0,
      uploadedDataList: [],
      searchKeyword: '',
      selected: 'uploaded',
    }, () => {
      this.search.value = '';
      const newData = [];
      this.getLeftProjectList();
      updateTreeIndex(newData);
      handleTabChange('projects');
    });
  }

  handleScroll = (event) => {
    const {
      getUploadedData,
      state: {
        error, isLoadingScroll, hasMore, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isLoadingScroll || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getUploadedData(currentPage + 1);
    }
  };

  handleToggle = (id, viewPoint, string) => {
    const { selectedIndex, activeTab } = this.state;
    const { handleToggle } = this.props;
    let newState;

    if (activeTab === 'files') {
      if (selectedIndex.indexOf(id) > -1) {
        newState = selectedIndex.filter((item) => {
          return item !== id;
        });
      } else {
        newState = [...selectedIndex, id];
      }
      this.setState({
        selectedIndex: newState,
      });
    } else if (activeTab === 'projects') {
      const isExist = selectedIndex.map((item) => {
        return item[string];
      }).indexOf(id);
      if (isExist > -1) {
        newState = selectedIndex.filter((item) => {
          return item[string] !== id;
        });
      } else {
        newState = [
          ...selectedIndex,
          { [string]: id, view_point: viewPoint },
        ];
      }
      this.setState({
        selectedIndex: newState,
      });
    }
    handleToggle(newState);
  };

  handleAddtoBookmark() {
    const { selectedIndex, uploadedDataList, activeTab } = this.state;
    const { createMyBookmark } = this.props;

    if (activeTab === 'files') {
      const selectedData = uploadedDataList.filter((item) => {
        return selectedIndex.indexOf(item.id) > -1;
      });

      const newData = selectedData.map((item) => {
        return {
          uploaded_file_id: item.targetId,
          view_point: item.viewPoint,
        };
      });

      const newObj = {
        selected: newData,
      };

      createMyBookmark(newObj);
    } else {
      const newObj = {
        selected: selectedIndex,
      };

      createMyBookmark(newObj);
    }
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  getUploadedData = (pageNo, limit) => {
    const { uploadedDataList, searchKeyword, selected } = this.state;
    const { translate, getLeftData } = this.props;
    const page = pageNo || 1;
    const perPage = limit || 20;

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isLoadingFiles: true,
      });
    }

    api
      .getUploadedData(
        {
          search: searchKeyword,
          page,
          limit: perPage,
          order: selected,
        }
      )
      .then((response) => {
        const nextUploadedDataList = response.response.map((item) => {
          return {
            extraData: item.extra_data,
            id: item.id,
            isPolicyViolation: item.is_policy_violation,
            isRealTimeUpdate: item.is_realtime_update,
            name: item.name,
            targetId: item.target_id.uploaded_file_id,
            uploadedAt: item.uploaded_at,
            uploadedGrade: item.uploaded_grade,
            viewPoint: item.view_point,
          };
        });
        this.setState({
          currentPage: response.pagination.current,
          nextPage: response.pagination.next,
          hasMore: response.pagination.next !== null,
          isLoading: false,
          isLoadingFiles: false,
          uploadedDataList: [...uploadedDataList, ...nextUploadedDataList],
        }, () => {
          const newData = [...uploadedDataList, ...nextUploadedDataList];
          getLeftData(newData, 'files');
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: translate('modal.error.error_load'),
          isLoading: false,
          isLoadingFiles: false,
        });
      });

  };

  getLeftProjectList = (pageNo, limit) => {
    const {
      targetObject, parentId, projectDataList, projectSize, searchKeyword, selected
    } = this.state;
    const { translate, getLeftData } = this.props;
    const page = pageNo || 1;
    const perPage = limit || projectSize;

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isLoadingTree: true,
        loadingIndex: 'project',
      });
    }

    api
      .getLeftProjectList(
        {
          search: searchKeyword,
          target_object: targetObject,
          object_parent_id: parentId,
          page,
          limit: perPage,
          order: selected,
        }
      )
      .then((response) => {
        const nextProjectDataList = response.response.map((item) => {
          return {
            data: item,
            children: [],
          };
        });

        this.setState({
          isLoading: false,
          isLoadingTree: false,
          loadingIndex: '',
          currentPage: response.pagination.current,
          nextPage: response.pagination.next,
          projectSize: response.pagination.per_page,
          hasMoreProject: response.pagination.next !== null,
          projectDataList: [...projectDataList, ...nextProjectDataList],
        }, () => {
          const newData = [...projectDataList, ...nextProjectDataList];
          getLeftData(newData, 'project');
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: translate('modal.error.error_load'),
          isLoading: false,
          isLoadingTree: false,
          loadingIndex: '',
        });
      });
  };

  getLeftProjectVersionList(pageNo, limit, parentIndex) {
    const {
      targetObject, parentId, projectDataList, hasMoreProjectVersion, projectVersionSize, searchKeyword, selected
    } = this.state;
    const { getLeftData } = this.props;
    const page = pageNo || 1;
    const perPage = limit || projectVersionSize;
    const { translate } = this.props;

    if (page === 1) {
      this.setState({
        isLoadingTree: true,
        loadingIndex: `${parentIndex}-project_version`,
      });
    } else {
      this.setState({
        isShowMoreLoading: true,
      });
    }

    api
      .getLeftProjectList(
        {
          search: searchKeyword,
          target_object: targetObject,
          object_parent_id: parentId,
          page,
          limit: perPage,
          order: selected,
        }
      )
      .then((response) => {
        const projectVersionList = response.response.map((item) => {
          return {
            data: item,
            children: [],
          };
        });

        let newData;
        const isNext = response.pagination.next;
        const newObject = {
          parentIndex,
          isNext,
        };

        if (hasMoreProjectVersion.length !== 0) {
          newData = hasMoreProjectVersion.filter((item) => { return !(item.parentIndex === parentIndex); });
        } else {
          newData = hasMoreProjectVersion;
        }

        const newProjectDataList = Update(projectDataList, {
          [parentIndex]: {
            children: {
              $push: projectVersionList,
            },
          },
        });

        this.setState({
          isLoadingTree: false,
          isShowMoreLoading: false,
          loadingIndex: '',
          projectDataList: newProjectDataList,
          hasMoreProjectVersion: [...newData, newObject],
        }, () => {
          getLeftData(newProjectDataList, 'project');
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: translate('modal.error.error_load'),
          isLoadingTree: false,
          isShowMoreLoading: false,
          loadingIndex: '',
        });
      });
  }

  getLeftReportList(pageNo, limit, parentIndex, childIndex) {
    const {
      targetObject, parentId, projectDataList, hasMoreReport, projectReportSize, searchKeyword, selected
    } = this.state;
    const { translate, getLeftData } = this.props;
    const page = pageNo || 1;
    const perPage = limit || projectReportSize;

    if (page === 1) {
      this.setState({
        isLoadingTree: true,
        loadingIndex: `${parentIndex}-${childIndex}-report`,
      });
    } else {
      this.setState({
        isShowMoreLoading: true,
      });
    }

    api
      .getLeftProjectList(
        {
          search: searchKeyword,
          target_object: targetObject,
          object_parent_id: parentId,
          page,
          limit: perPage,
          order: selected,
        }
      )
      .then((response) => {
        const projectVersionList = response.response.map((item) => {
          return {
            data: item,
            children: [],
          };
        });

        let newData;
        const isNext = response.pagination.next;
        const newObject = {
          parentIndex,
          childIndex,
          isNext,
        };

        if (hasMoreReport.length !== 0) {
          newData = hasMoreReport.filter((item) => { return !(item.parentIndex === parentIndex && item.childIndex === childIndex); });
        } else {
          newData = hasMoreReport;
        }

        const nextProjectData = Update(projectDataList, {
          [parentIndex]: {
            children: {
              [childIndex]: {
                children: {
                  $push: projectVersionList,
                },
              },
            },
          },
        });

        this.setState({
          isLoadingTree: false,
          isShowMoreLoading: false,
          loadingIndex: '',
          projectDataList: nextProjectData,
          hasMoreReport: [...newData, newObject],
        }, () => {
          getLeftData(nextProjectData, 'project');
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: translate('modal.error.error_load'),
          isLoadingTree: false,
          isShowMoreLoading: false,
          loadingIndex: '',
        });
      });
  }

  getMoreListData = (index, targetId, targetObject) => {
    const {
      projectDataList, projectVersionSize, projectReportSize, nextPage, projectSize
    } = this.state;

    if (targetObject === 'project_version') {
      const pageNext = (Math.ceil(projectDataList[index].children.length) / projectVersionSize) + 1;
      this.setState({
        targetObject,
        parentId: targetId,
      }, () => {
        this.getLeftProjectVersionList(pageNext, projectVersionSize, index);
      });
    } else if (targetObject === 'report') {
      const string = index.split('-');
      const pageNext = (Math.ceil(projectDataList[Number(string[0])].children[Number(string[1])].children.length) / projectReportSize) + 1;
      this.setState({
        targetObject,
        parentId: targetId,
      }, () => {
        this.getLeftReportList(pageNext, projectReportSize, Number(string[0]), Number(string[1]));
      });
    } else {
      this.setState({
        targetObject: 'project',
        parentId: 0,
      }, () => {
        this.getLeftProjectList(nextPage, projectSize);
      });
    }
  };

  toggleRow = (index, targetId, targetObject) => {
    const {
      activeIndex, projectDataList, hasMoreProjectVersion, hasMoreReport, projectVersionSize, projectReportSize
    } = this.state;
    const { getLeftData, updateTreeIndex } = this.props;

    const isActive = activeIndex.includes(index);
    const updatedActiveIndex = isActive
      ? activeIndex.filter((i) => { return !(typeof i === 'string' ? Number(i.split('-')[0]) : i) === index; })
      : [...activeIndex, index];

    let updatedProjectDataList = projectDataList;
    let updateFn = null;
    let updatedHasMoreProjectVersion = hasMoreProjectVersion;
    let updatedHasMoreReport = hasMoreReport;

    if (targetObject === 'project_version') {
      updateFn = () => { return this.getLeftProjectVersionList(1, projectVersionSize, index); };
      if (!isActive) {
        updatedProjectDataList = Update(projectDataList, {
          [index]: { children: { $set: [] } },
        });
      } else {
        updatedHasMoreProjectVersion = hasMoreProjectVersion.filter((item) => { return item.parentIndex !== index; });
        updatedHasMoreReport = hasMoreReport.filter((item) => { return item.parentIndex !== index; });
      }
    } else if (targetObject === 'report') {
      const [parentIndex, childIndex] = index.split('-').map(Number);
      updateFn = () => { return this.getLeftReportList(1, projectReportSize, parentIndex, childIndex); };
      if (!isActive) {
        updatedProjectDataList = Update(projectDataList, {
          [parentIndex]: { children: { [childIndex]: { children: { $set: [] } } } },
        });
      } else {
        updatedHasMoreReport = hasMoreReport.filter((item) => { return !(item.parentIndex === parentIndex && item.childIndex === childIndex); });
      }
    }

    this.setState({
      projectDataList: updatedProjectDataList,
      hasMoreProjectVersion: updatedHasMoreProjectVersion,
      hasMoreReport: updatedHasMoreReport,
      ...(isActive ? {} : { targetObject, parentId: targetId }),
    }, () => {
      if (!isActive) {
        updateFn();
      }
      getLeftData(updatedProjectDataList, 'project');
    });

    updateTreeIndex(updatedActiveIndex);
  };

  clearSearch() {
    const { activeTab } = this.state;

    this.search.value = '';
    if (activeTab === 'files') {
      this.setState(
        {
          searchKeyword: '',
          uploadedDataList: [],
        },
        () => {
          this.getUploadedData();
        }
      );
    } else {
      this.setState(
        {
          searchKeyword: '',
          projectDataList: [],
        },
        () => {
          this.getLeftProjectList();
        }
      );
    }
  }

  renderList(obj) {
    const grade = obj.uploadedGrade;
    let gradeIcon;
    const isPolicy = obj.isPolicyViolation;
    const fileName = obj.name;
    const projectName = obj.extraData.project;
    const projectVersionName = obj.extraData.project_version;
    const style = {
      fontSize: '12px',
      fontWeight: '600',
      background: '#f4f4f4',
      color: '#7434fe',
    };

    if (grade === 'A') {
      gradeIcon = <p className="grade">A</p>;
    } else if (grade === 'B') {
      gradeIcon = <p className="grade">B</p>;
    } else if (grade === 'C') {
      gradeIcon = <p className="grade">C</p>;
    } else if (grade === 'D') {
      gradeIcon = <p className="grade">D</p>;
    } else if (grade === '-') {
      gradeIcon = <p className="grade">-</p>;
    }
    return (
      <a>
        {gradeIcon}
        <Popup
          trigger={<span>{fileName}</span>}
          content={`${projectName} / ${projectVersionName}`}
          position="top left"
          style={style}
          size="small"
          className="scan"
          on="hover"
          mouseEnterDelay={350}
          //inverted
        />
        {isPolicy ? <Icon name="exclamation" /> : null}
      </a>
    );
  }

  renderShowMore(projectIndex, targetId, type) {
    const { translate } = this.props;
    const {
      hasMoreProject, hasMoreProjectVersion, hasMoreReport, isShowMoreLoading, projectSize
    } = this.state;

    if (type === 'project_version') {
      const selectedIndex = hasMoreProjectVersion.findIndex((item) => {
        return item.parentIndex === projectIndex;
      });

      if (typeof selectedIndex === 'undefined') {
        return null;
      }

      if (selectedIndex === -1) {
        return null;
      }

      if (hasMoreProjectVersion[selectedIndex].isNext !== null) {
        if (isShowMoreLoading) {
          return (
            <li>
              <img
                src={progress}
                role="presentation"
                style={{
                  width: 14,
                  height: 14,
                  margin: '5px 0 0 15px',
                }}
                alt=""
              />
            </li>
          );
        }
        return (
          <li>
            <a
              className="show_more"
              onClick={() => { return this.getMoreListData(projectIndex, targetId, 'project_version'); }}
              onKeyUp={() => { return this.getMoreListData(projectIndex, targetId, 'project_version'); }}
            >
              {translate('my_page.show_more')}
            </a>
          </li>
        );
      }
      return null;
    }
    if (type === 'report') {
      const string = projectIndex.split('-');

      const selectedIndex = hasMoreReport.findIndex((item) => { return (item.parentIndex === Number(string[0]) && item.childIndex === Number(string[1])); });

      if (typeof selectedIndex === 'undefined') {
        return null;
      }

      if (selectedIndex === -1) {
        return null;
      }

      if (hasMoreReport[selectedIndex].isNext !== null) {
        if (isShowMoreLoading) {
          return (
            <li>
              <img
                src={progress}
                role="presentation"
                style={{
                  width: 14,
                  height: 14,
                  margin: '5px 0 0 15px',
                }}
                alt=""
              />
            </li>
          );
        }
        return (
          <li>
            <a
              className="show_more"
              onClick={() => { return this.getMoreListData(projectIndex, targetId, 'report'); }}
              onKeyUp={() => { return this.getMoreListData(projectIndex, targetId, 'report'); }}
            >
              {translate('my_page.show_more')}
            </a>
          </li>
        );
      }
      return null;
    }
    if (type === 'project') {
      if (hasMoreProject) {
        return (
          <li>
            <a
              className="show_more"
              onClick={() => { return this.getMoreListData(projectIndex, projectSize, 'project'); }}
              onKeyUp={() => { return this.getMoreListData(projectIndex, projectSize, 'project'); }}
            >
              {translate('my_page.show_more')}
            </a>
          </li>
        );
      }
      return null;
    }

  }

  render() {
    const {
      uploadedDataList,
      activeTab,
      error,
      isLoading,
      isLoadingFiles,
      isLoadingTree,
      loadingIndex,
      selectedIndex,
      errSearch,
      activeIndex,
      hasMoreProject,
      projectDataList,
      nextPage,
      selected,
    } = this.state;

    const { translate } = this.props;

    const sortColumn = activeTab === 'files' ? (
      [
        { key: 1, text: translate('modal.new_scan.title.newest'), value: 'uploaded' },
        { key: 2, text: translate('modal.new_scan.title.atoz'), value: 'report_r' },
        { key: 3, text: translate('modal.new_scan.title.ztoa'), value: 'report' },
      ]
    ) : (
      [
        { key: 1, text: translate('modal.new_scan.title.newest'), value: 'uploaded' },
        { key: 2, text: translate('modal.new_scan.title.atoz'), value: 'project_r' },
        { key: 3, text: translate('modal.new_scan.title.ztoa'), value: 'project' },
      ]
    );

    const getListStyle = () => {
      return {
        padding: 8,
        width: '100%',
        zIndex: '1',
      };
    };

    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        userSelect: 'none',
        background: isDragging && '#fae7ff',
        ...draggableStyle,
        zIndex: '10',
      };
    };

    const isExist = (id, string) => {
      return selectedIndex.map((item) => {
        return item[string];
      }).indexOf(id);
    };

    return (
      <div className="left_menu_type_2">
        <div className="left_menu_type_2_contents_wrap">
          <div className="left_menu_type_2_content content_bottom">
            <div className="left_menu_type_2_content_tab">
              <a
                className={cx('tab_item', {
                  active: activeTab === 'files',
                })}
                onClick={this.handleTabChange}
                onKeyUp={this.handleTabChange}
              >
                {translate('my_page.files')}
              </a>
              <a
                className={cx('tab_item', {
                  active: activeTab === 'projects',
                })}
                onClick={this.handleTabChange}
                onKeyUp={this.handleTabChange}
              >
                {translate('my_page.projects')}
              </a>
            </div>
            <div className="projects_list_wrap">
              <div className="projects_search_wrap">
                <div className="projects_search_inner">
                  <img src={searchImg} alt="" className="search_icon" />
                  <input
                    type="text"
                    className="projects_search"
                    placeholder={activeTab === 'files' ? translate('modal.new_scan.place_holder.uploaded_files') : translate('modal.new_scan.place_holder.project_version_file_name')}
                    ref={(ref) => {
                      this.search = ref;
                    }}
                    onKeyPress={this.handleSearch}
                  />
                  <a
                    className="reset_icon"
                    onClick={this.clearSearch}
                    onKeyUp={this.clearSearch}
                  >
                    x
                  </a>
                  {errSearch && (
                    <Label basic color="red" pointing>
                      {translate('contents_header.message.least_two_required_to_search')}
                    </Label>
                  )}
                </div>
              </div>
              {
                !isLoading ? (
                  <div>
                    {
                      activeTab === 'files'
                      && (
                        <div className="projects_list">
                          <Scrollbars
                            onScroll={this.handleScroll}
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <Droppable droppableId="all-files">
                              {(provided, snapshot) => {
                                return (
                                  <ul
                                    className="depth_1"
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                    {...provided.droppableProps}
                                  >
                                    {uploadedDataList.length !== 0
                                      ? uploadedDataList.map((item, index) => {
                                        return (
                                          <Draggable
                                            key={item.id}
                                            draggableId={`file-${item.id}`}
                                            index={index}
                                          >
                                            {(draggableProvided, draggableSnapshot) => {
                                              return (
                                                <li
                                                  className={cx('expand', {
                                                    selected: selectedIndex.indexOf(item.id) >= 0,
                                                  })}
                                                  onClick={() => {
                                                    return this.handleToggle(item.id);
                                                  }}
                                                  onKeyUp={() => {
                                                    return this.handleToggle(item.id);
                                                  }}
                                                  ref={draggableProvided.innerRef}
                                                  {...draggableProvided.draggableProps}
                                                  {...draggableProvided.dragHandleProps}
                                                  style={getItemStyle(
                                                    draggableSnapshot.isDragging,
                                                    draggableProvided.draggableProps.style
                                                  )}
                                                >
                                                  {this.renderList(item)}
                                                </li>
                                              );
                                            }}
                                          </Draggable>
                                        );
                                      })
                                      : null}
                                    {provided.placeholder}
                                    {error && <div className="error_log">{error}</div>}
                                    {isLoadingFiles && <Loader size="small" active={isLoadingFiles} inline="centered" />}
                                  </ul>
                                );
                              }}
                            </Droppable>
                          </Scrollbars>
                        </div>
                      )
                    }
                    {
                      activeTab === 'projects'
                      && (
                        <div className="projects_list">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <Droppable droppableId="all-project">
                              {
                                (provided, snapshot) => {
                                  return (
                                    <ul
                                      className="depth_1"
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                      style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                      {
                                        projectDataList.length !== 0
                                        && projectDataList.map((project, projectIndex) => {
                                          return (
                                            <Draggable
                                              key={project.data.id}
                                              draggableId={`project-${project.data.id}`}
                                              index={projectIndex}
                                            >
                                              {
                                                (draggableProvided, draggableSnapshot) => {
                                                  return (
                                                    <li
                                                      className={cx({
                                                        expand: activeIndex.indexOf(projectIndex) > -1,
                                                      })}
                                                      ref={draggableProvided.innerRef}
                                                      {...draggableProvided.draggableProps}
                                                      style={getItemStyle(
                                                        draggableSnapshot.isDragging,
                                                        draggableProvided.draggableProps.style
                                                      )}
                                                    >
                                                      <a
                                                        {...draggableProvided.dragHandleProps}
                                                      >
                                                        <p
                                                          onClick={() => { return this.toggleRow(projectIndex, project.data.target_id.project_id, 'project_version'); }}
                                                          onKeyUp={() => { return this.toggleRow(projectIndex, project.data.target_id.project_id, 'project_version'); }}
                                                          style={{ cursor: 'pointer', margin: '0' }}
                                                        >
                                                          <img className="fold_icon" src={foldImg} role="presentation" alt="" />
                                                          <img className="expand_icon" src={expandImg} role="presentation" alt="" />
                                                        </p>
                                                        <span
                                                          className={cx({
                                                            selected: isExist(project.data.id, 'project_id') > -1,
                                                          })}
                                                          onClick={() => {
                                                            return this.handleToggle(project.data.id, project.data.view_point, 'project_id');
                                                          }}
                                                          onKeyUp={() => {
                                                            return this.handleToggle(project.data.id, project.data.view_point, 'project_id');
                                                          }}
                                                        >
                                                          {project.data.name}

                                                        </span>
                                                      </a>
                                                      <Droppable droppableId={`project_version-${project.data.id}`}>
                                                        {
                                                          (versionProvided, versionSnapshot) => {
                                                            return (
                                                              <ul
                                                                className="depth_2"
                                                                ref={versionProvided.innerRef}
                                                                style={getListStyle(versionSnapshot.isDraggingOver)}
                                                                {...versionProvided.droppableProps}
                                                              >
                                                                {
                                                                  project.children.length !== 0
                                                                  && project.children.map((projectVersion, versionIndex) => {
                                                                    return (
                                                                      <Draggable
                                                                        key={projectVersion.data.id}
                                                                        draggableId={`version-${projectVersion.data.id}`}
                                                                        index={versionIndex}
                                                                      >
                                                                        {
                                                                          (draggableVersionProvided, draggabelVersionSnapshot) => {
                                                                            return (
                                                                              <li
                                                                                className={cx({
                                                                                  expand: activeIndex.indexOf(`${projectIndex}-${versionIndex}`) > -1,
                                                                                })}
                                                                                ref={draggableVersionProvided.innerRef}
                                                                                {...draggableVersionProvided.draggableProps}
                                                                                style={getItemStyle(
                                                                                  draggabelVersionSnapshot.isDragging,
                                                                                  draggableVersionProvided.draggableProps.style
                                                                                )}
                                                                              >
                                                                                <a
                                                                                  {...draggableVersionProvided.dragHandleProps}
                                                                                >
                                                                                  <p
                                                                                    onClick={() => { return this.toggleRow(`${projectIndex}-${versionIndex}`, projectVersion.data.target_id.project_version_id, 'report'); }}
                                                                                    onKeyUp={() => { return this.toggleRow(`${projectIndex}-${versionIndex}`, projectVersion.data.target_id.project_version_id, 'report'); }}
                                                                                    style={{ cursor: 'pointer', margin: '0' }}
                                                                                  >
                                                                                    <img className="fold_icon" src={foldImg} role="presentation" alt="" />
                                                                                    <img className="expand_icon" src={expandImg} role="presentation" alt="" />
                                                                                  </p>
                                                                                  <span
                                                                                    className={cx({
                                                                                      selected: isExist(projectVersion.data.id, 'project_version_id') > -1,
                                                                                    })}
                                                                                    onClick={() => {
                                                                                      return this.handleToggle(projectVersion.data.id, projectVersion.data.view_point, 'project_version_id');
                                                                                    }}
                                                                                    onKeyUp={() => {
                                                                                      return this.handleToggle(projectVersion.data.id, projectVersion.data.view_point, 'project_version_id');
                                                                                    }}
                                                                                  >
                                                                                    {projectVersion.data.name}

                                                                                  </span>
                                                                                </a>
                                                                                <Droppable droppableId={`report-${project.data.id}`}>
                                                                                  {
                                                                                    (reportProvided, reportSnapshot) => {
                                                                                      return (
                                                                                        <ul
                                                                                          className="depth_3"
                                                                                          ref={reportProvided.innerRef}
                                                                                          style={getListStyle(reportSnapshot.isDraggingOver)}
                                                                                          {...reportProvided.droppableProps}
                                                                                        >
                                                                                          {
                                                                                            projectVersion.children.length !== 0
                                                                                            && projectVersion.children.map((report, reportIndex) => {
                                                                                              return (
                                                                                                <Draggable
                                                                                                  key={report.data.id}
                                                                                                  draggableId={`report-${projectVersion.data.id}-${report.data.id}`}
                                                                                                  index={reportIndex}
                                                                                                >
                                                                                                  {(draggableReportProvided, draggableReportSnapshot) => {
                                                                                                    return (
                                                                                                      <li
                                                                                                        ref={draggableReportProvided.innerRef}
                                                                                                        {...reportProvided.draggableProps}
                                                                                                        style={getItemStyle(
                                                                                                          draggableReportSnapshot.isDragging,
                                                                                                          draggableReportProvided.draggableProps.style
                                                                                                        )}
                                                                                                      >
                                                                                                        <a
                                                                                                          {...draggableReportProvided.dragHandleProps}
                                                                                                        >
                                                                                                          <img src={bulletImg} role="presentation" alt="" />
                                                                                                          <span
                                                                                                            className={cx({
                                                                                                              selected: isExist(report.data.id, 'uploaded_file_id') > -1,
                                                                                                            })}
                                                                                                            onClick={() => {
                                                                                                              return this.handleToggle(report.data.id, report.data.view_point, 'uploaded_file_id');
                                                                                                            }}
                                                                                                            onKeyUp={() => {
                                                                                                              return this.handleToggle(report.data.id, report.data.view_point, 'uploaded_file_id');
                                                                                                            }}
                                                                                                          >
                                                                                                            {report.data.name}

                                                                                                          </span>
                                                                                                          {
                                                                                                            report.data.is_policy_violation ? (
                                                                                                              <Icon name="exclamation" />
                                                                                                            ) : null
                                                                                                          }
                                                                                                        </a>
                                                                                                      </li>
                                                                                                    );
                                                                                                  }}
                                                                                                </Draggable>
                                                                                              );
                                                                                            })
                                                                                          }
                                                                                          {
                                                                                            projectVersion.children.length !== 0
                                                                                          && this.renderShowMore(`${projectIndex}-${versionIndex}`, projectVersion.data.target_id.project_version_id, 'report')
                                                                                          }
                                                                                          {
                                                                                            isLoadingTree && loadingIndex === `${projectIndex}-${versionIndex}-report`
                                                                                          && <Loader size="small" active={isLoadingTree} inline="centered" />
                                                                                          }
                                                                                          {reportProvided.placeholder}
                                                                                        </ul>
                                                                                      );
                                                                                    }
                                                                                  }
                                                                                </Droppable>
                                                                              </li>
                                                                            );
                                                                          }
                                                                        }
                                                                      </Draggable>
                                                                    );
                                                                  })
                                                                }
                                                                {
                                                                  project.children.length !== 0
                                                                && this.renderShowMore(projectIndex, project.data.target_id.project_id, 'project_version')
                                                                }
                                                                {
                                                                  isLoadingTree && loadingIndex === `${projectIndex}-project_version`
                                                                && <Loader size="small" active={isLoadingTree} inline="centered" />
                                                                }
                                                                {versionProvided.placeholder}
                                                              </ul>
                                                            );
                                                          }
                                                        }
                                                      </Droppable>
                                                    </li>
                                                  );
                                                }
                                              }
                                            </Draggable>
                                          );
                                        })
                                      }
                                      {
                                        hasMoreProject
                                      && this.renderShowMore(nextPage, 20, 'project')
                                      }
                                      {
                                        isLoadingTree && loadingIndex === 'project'
                                      && <Loader size="small" active={isLoadingTree} inline="centered" />
                                      }
                                      {provided.placeholder}
                                    </ul>
                                  );
                                }
                              }
                            </Droppable>
                          </Scrollbars>
                        </div>
                      )
                    }
                  </div>
                ) : (
                  <Loader active={isLoading} inline="centered" />
                )
              }
              <div className="newest">
                <Dropdown
                  selection
                  options={sortColumn}
                  value={selected}
                  onChange={this.handleSortingChange}
                />
              </div>
            </div>
          </div>
        </div>
        {
          selectedIndex.length === 0 ? (
            <a
              className="add_button"
              style={{
                pointerEvents: 'none',
                cursor: 'default',
                opacity: '.45',
              }}
            >
              <span className="add_button_inner">
                {translate('modal.button.add')}
                <br />
                <img src={combinedShapeImg} alt="" />
              </span>
            </a>
          ) : (
            <a
              className="add_button"
              onClick={this.handleAddtoBookmark}
              onKeyUp={this.handleAddtoBookmark}
              style={{ cursor: 'pointer' }}
            >
              <span className="add_button_inner">
                {translate('modal.button.add')}
                <br />
                <img src={combinedShapeImg} alt="" />
              </span>
            </a>
          )
        }
      </div>
    );
  }
}

export default NavigationBar;
